import React from "react";
// Components
import Table from "../../../../components/Table/Table";
import { ScenarioResult } from "../Result/QuoteEquity";

// TEMPORARY: dumps every field the API returns, see resultRows.ts.
import { flattenResultRows } from "../resultRows";

/** Constants for reusable values */
const CLASSES = {
  TEXT_LEFT: "text-left",
};

interface TabCompositionProps {
  scenarioData: ScenarioResult;
}

/** Component */
const TabComposition: React.FC<TabCompositionProps> = ({ scenarioData }) => {
  const rows = flattenResultRows(
    scenarioData as unknown as Record<string, any>,
  );

  return (
    <Table
      headers={undefined}
      noMobile={undefined}
      firstRow={undefined}
      loadMoreBtn={undefined}
      hasMoreRows={undefined}
      onLoadMore={undefined}
      data={rows.map(({ label, value }) => [
        { value: label, className: CLASSES.TEXT_LEFT },
        { value, className: CLASSES.TEXT_LEFT },
      ])}
    />
  );
};

export default TabComposition;
